import { PencilSquareIcon } from '@heroicons/react/24/outline'
import { Link }             from 'react-router-dom'

export default function SettingsShopTab(): JSX.Element {
  return (
    <div className="flex flex-col space-y-4 w-full">
      <div className="flex items-center justify-between w-full">
        <div>Categories</div>
        <Link to={ `/settings/shop/categories` }>
          <button className="flex items-center text-sm text-blue-input font-medium px-3 py-1 bg-yellow-300 rounded-full">
            <PencilSquareIcon className="w-4 h-4" />
            <span className="pl-1 text-left">Edit</span>
          </button>
        </Link>
      </div>

      <div className="flex items-center justify-between w-full">
        <div>Delivery Options</div>
        <Link to={ `/settings/shop/delivery-options` }>
          <button className="flex items-center text-sm text-blue-input font-medium px-3 py-1 bg-yellow-300 rounded-full">
            <PencilSquareIcon className="w-4 h-4" />
            <span className="pl-1 text-left">Edit</span>
          </button>
        </Link>
      </div>

      <div className="flex items-center justify-between w-full">
        <div>Size Guides</div>
        <Link to={ `/settings/shop/size-guides` }>
          <button className="flex items-center text-sm text-blue-input font-medium px-3 py-1 bg-yellow-300 rounded-full">
            <PencilSquareIcon className="w-4 h-4" />
            <span className="pl-1 text-left">Edit</span>
          </button>
        </Link>
      </div>

      <div className="flex items-center justify-between w-full">
        <div>Variants</div>
        <Link to={ `/settings/shop/variants` }>
          <button className="flex items-center text-sm text-blue-input font-medium px-3 py-1 bg-yellow-300 rounded-full">
            <PencilSquareIcon className="w-4 h-4" />
            <span className="pl-1 text-left">Edit</span>
          </button>
        </Link>
      </div>

      <div className="flex items-center justify-between w-full">
        <div>Variants Variations</div>
        <Link to={ `/settings/shop/variants-variations` }>
          <button className="flex items-center text-sm text-blue-input font-medium px-3 py-1 bg-yellow-300 rounded-full">
            <PencilSquareIcon className="w-4 h-4" />
            <span className="pl-1 text-left">Edit</span>
          </button>
        </Link>
      </div>

      <div className="flex items-center justify-between w-full">
        <div>Products</div>
        <Link to={ `/settings/shop/products` }>
          <button className="flex items-center text-sm text-blue-input font-medium px-3 py-1 bg-yellow-300 rounded-full">
            <PencilSquareIcon className="w-4 h-4" />
            <span className="pl-1 text-left">Edit</span>
          </button>
        </Link>
      </div>
    </div>
  )
}
